import { render } from "./guide-success.vue?vue&type=template&id=65693fa5"
import script from "./guide-success.vue?vue&type=script&lang=js"
export * from "./guide-success.vue?vue&type=script&lang=js"

import "./guide-success.vue?vue&type=style&index=0&id=65693fa5&lang=less"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__